import React, { Component } from "react";
import PropertyInformation from "../Shared/Information/PropertyInformation";
import { connect } from "react-redux";
import TenantInformation from "../Shared/Information/TenantInformation";
import Title from "../../Helpers/Title";
import { loadTenantProperty } from "../../../actions/tenantActions";
import { Grid, Button } from "@material-ui/core";
import LinkHelper from "../../Helpers/Link";
import PasswordChange from "../../PasswordChange";

class TenantProfileInfo extends Component {

    componentDidMount() {
        this.props.loadProperty();
    }

    render() {
        const { property, profile } = this.props;
        console.log( "PROFILE >>", profile );
        if ( !profile )
            return <div/>
        return (
            <div className="User-content">
                <Title title="Property information"/>
                <PropertyInformation
                    title={
                        <Grid container direction="row" justify="space-between" alignItems="center">
                            <div>Property that you are looking for</div>
                            <div>
                                <LinkHelper to={`/user/edit/property/${profile.properties[0].id}`}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                    >
                                        Edit
                                    </Button>
                                </LinkHelper>
                            </div>
                        </Grid>
                    }
                    properties={property}
                />
                <TenantInformation
                    isUser
                    title={
                        <Grid container direction="row" justify="space-between" alignItems="center">
                            <div>Your profile</div>
                            <div>
                                <LinkHelper to={`/user/edit/profile`}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="large"
                                    >
                                        Edit profile
                                    </Button>
                                </LinkHelper>
                            </div>
                        </Grid>
                    }
                    profile={profile}
                />
                <PasswordChange/>
            </div>
        );
    }

}

export default connect(
    state => {
        return {
            property: state.user.data.properties[0],
            profile: state.user.data
        }
    },
    dispatch => {
        return {
            loadProperty: () => dispatch( loadTenantProperty() )
        }
    }
)( TenantProfileInfo );